import { useCallback, useEffect, useState } from 'react';
import { PageHeader, SegmentedControl } from '@/components/app';
import KPICards from '@/components/Dashboard/KPICards';
import Charts from '@/components/Dashboard/Charts';
import RecentPayments from '@/components/Dashboard/RecentPayments';
import { usersApi, type DashboardStats } from '@/api/users';
import { getErrorMessage } from '@/lib/errors';
import { formatTashkentTime } from '@/lib/datetime';

/** Окно графика и «новых пользователей»: срез 30-дневного ряда, который отдаёт API. */
type Period = '7' | '14' | '30';
const PERIODS = [
  { value: '7' as const, label: '7 дней' },
  { value: '14' as const, label: '14 дней' },
  { value: '30' as const, label: '30 дней' },
];

export default function DashboardPage() {
  const [stats, setStats] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [fetchedAt, setFetchedAt] = useState<Date | null>(null);
  const [period, setPeriod] = useState<Period>('30');
  const periodDays = Number(period);

  const fetchStats = useCallback(
    () =>
      usersApi
        .getDashboardStats()
        .then((data) => {
          setStats(data);
          setFetchedAt(new Date());
        })
        .catch((err) => setError(getErrorMessage(err, 'Не удалось загрузить статистику')))
        .finally(() => setLoading(false)),
    [],
  );

  useEffect(() => {
    void fetchStats();
  }, [fetchStats]);

  const load = () => {
    setLoading(true);
    setError(null);
    void fetchStats();
  };

  return (
    <div className="flex flex-col gap-5">
      <PageHeader
        title="Сводка"
        subtitle={
          <>
            Данные за {periodDays} дней
            {fetchedAt && <>, обновлено в <span className="tabular-nums">{formatTashkentTime(fetchedAt)}</span></>}
          </>
        }
        actions={<SegmentedControl ariaLabel="Период" value={period} onChange={setPeriod} options={PERIODS} />}
      />
      <KPICards stats={stats} loading={loading} error={error} onRetry={load} periodDays={periodDays} />
      {!error && <Charts stats={stats} loading={loading} periodDays={periodDays} />}
      <RecentPayments />
    </div>
  );
}
